module.exports = "https://img.xiyuyouxi.com/saas/img/shop_img.0d6c5b0d.png";